import styled, { css } from 'styled-components';

const keyboardFocus = css`
  outline: 3px solid ${({ theme }) => theme.colors.softBlack};
  outline-offset: 2px;
`;

export const ChartSection = styled.section`
  margin-top: 22px;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 5px;
  padding: 18px;
  background: ${({ theme }) => theme.colors.white};

  h3 {
    margin: 0;
    color: ${({ theme }) => theme.colors.softBlack};
    font-size: 17px;
  }

  p {
    margin: 6px 0 0;
    color: ${({ theme }) => theme.colors.grey};
    font-size: 13px;
  }
`;

export const ChartViewport = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  height: 320px;
  margin-top: 18px;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    height: 300px;
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    height: 280px;
  }
`;

export const ChartPlot = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
`;

export const ChartCanvas = styled.div<{ dimmed?: boolean }>`
  position: absolute;
  inset: 0;
  opacity: ${({ dimmed }) => (dimmed ? 0.58 : 1)};

  > canvas {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const ChartStatus = styled.div<{ error?: boolean }>`
  position: absolute;
  top: 50%;
  right: 18px;
  left: 18px;
  transform: translateY(-50%);
  padding: 14px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme, error }) => (error ? theme.colors.red : theme.colors.grey)};
  text-align: center;
`;

export const ChartNotice = styled.div`
  flex: 0 0 auto;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 8px;
  padding: 10px 14px;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.softBlack};
  font-size: 13px;
  font-weight: 600;
  pointer-events: none;
  text-align: center;
`;

export const ChartContext = styled.p`
  margin: 12px auto 0;
  max-width: 1100px;
  color: ${({ theme }) => theme.colors.grey};
  font-size: 12px;
`;

export const RetryChartButton = styled.button`
  margin-top: 10px;
  border: 1px solid ${({ theme }) => theme.colors.main};
  border-radius: 4px;
  padding: 8px 12px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.main};
  cursor: pointer;

  &:focus-visible {
    ${keyboardFocus}
  }
`;

export const TextAlternative = styled.details`
  margin-top: 14px;
  color: ${({ theme }) => theme.colors.softBlack};

  summary {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.main};
    font-weight: 600;

    &:focus-visible {
      ${keyboardFocus}
    }
  }

  ul {
    margin: 10px 0 0;
    padding-left: 20px;
  }
`;
